export const ROLE_LABELS = {
  super_admin: "Super Administrateur",
  direction_generale: "Direction Générale",
  direction_commerciale: "Direction Commerciale",
  responsable: "Responsable",
  commercial: "Commercial",
  collaborateur: "Collaborateur",
  caissier: "Caissier",
  comptable: "Comptable",
  conducteur_vendeur: "Conducteur-vendeur",
  responsable_technique: "Responsable technique",
  technicien: "Technicien",
};
export const TECH_SUPERVISOR_ROLES = ["super_admin", "direction_generale", "responsable_technique"];

export const CAN_APPROVE_FUNDS = ["super_admin", "direction_generale", "direction_commerciale", "responsable"];
export const CAN_DISBURSE = ["super_admin", "direction_generale", "caissier"];
export const ACCOUNT_TYPES = [
  { value: "physique", label: "Caisse physique" },
  { value: "electronique", label: "Caisse électronique" },
  { value: "banque", label: "Compte bancaire" },
  { value: "autre", label: "Autre" },
];
export const CASH_DENOMINATIONS = [10000, 5000, 2000, 1000, 500, 250, 200, 100, 50, 25, 10, 5];

export const MODULE_LABELS = {
  dashboard: "Tableau de bord", prospects: "Prospects / CRM", clients: "Clients",
  devis: "Devis", factures: "Factures", achats: "Achats", fournisseurs: "Fournisseurs",
  stock: "Stock", livraisons: "Livraisons", projets: "Projets", rh: "RH & Temps",
  paie: "Paie", tresorerie: "Trésorerie", finance: "Finance / Compta",
  comptabilite: "Comptabilité",
  ouvriers: "Ouvriers", artisans: "Artisans", commandes: "Commandes (Achats)",
  creances: "Créances", dettes: "Dettes", technique: "Technique (exécution chantier)", portail: "Portail client",
  ressources: "Ressources (Formation & Guides)", rapports: "Rapports",
  admin: "Admin & Communication", parametres: "Paramètres / Utilisateurs",
};
export const MODULE_LEVELS = [
  { value: "aucun", label: "Aucun accès" },
  { value: "basique", label: "Basique (lecture)" },
  { value: "intermediaire", label: "Intermédiaire (lecture + écriture)" },
  { value: "total", label: "Total (tout)" },
];
const LEVEL_ACTIONS = { aucun: [], basique: ["view", "export"], intermediaire: ["view", "create", "edit", "validate", "export"], total: ["view", "create", "edit", "delete", "validate", "export", "configure"] };
export const VALIDATION_ACTIONS = [["view", "Voir le module"], ["view_all", "Voir toutes"], ["submit", "Soumettre"], ["approve", "Approuver"], ["reject", "Rejeter"],
  ["correction", "Demander correction"], ["reassign", "Réaffecter"], ["configure", "Gérer les circuits"], ["history", "Historique"], ["cancel", "Annuler"]];
export const PARTNER_ACTIONS = [["view", "Voir (ses dossiers)"], ["view_team", "Voir son équipe"], ["view_all", "Voir tout"], ["create", "Créer"], ["edit", "Modifier"],
  ["convert", "Convertir contact"], ["pipelines", "Gérer pipelines"], ["move", "Déplacer étape"], ["actions", "Actions"], ["opportunities", "Opportunités"],
  ["contracts", "Contrats"], ["finance", "Données financières"], ["delete", "Supprimer / archiver"], ["reports", "Rapports"], ["export", "Exporter"], ["configure", "Paramètres"]];
export const MODULE_ACTION_LEVELS = {
  validation: { aucun: [], basique: ["view", "submit", "history"], intermediaire: ["view", "submit", "history", "approve", "reject", "correction", "cancel"], total: VALIDATION_ACTIONS.map(([a]) => a) },
  partenariat: { aucun: [], basique: ["view", "reports"], intermediaire: ["view", "view_team", "create", "edit", "convert", "move", "actions", "opportunities", "contracts", "reports", "export"], total: PARTNER_ACTIONS.map(([a]) => a) },
};
export const ROUTE_MODULE = {
  "/": "dashboard", "/prospects": "prospects", "/opportunites": "opportunites", "/clients": "clients",
  "/devis": "devis", "/contrats": "contrats", "/factures": "factures", "/livraisons": "livraisons",
  "/prestations": "prestations", "/projets-clients": "projets_clients", "/modeles-contrats": "modeles_contrats",
  "/articles": "stock", "/mouvements-stock": "mouvements", "/inventaire": "inventaire", "/magasins": "magasins",
  "/achats": "achats", "/fournisseurs": "fournisseurs", "/commandes": "commandes",
  "/artisans": "artisans", "/ouvriers": "ouvriers", "/creances": "creances", "/dettes": "dettes",
  "/projets": "projets", "/taches": "taches", "/agenda": "agenda",
  "/collaborateurs": "rh", "/pointage": "pointage", "/feuilles-temps": "feuilles_temps", "/conges": "conges",
  "/tresorerie": "tresorerie", "/demandes-fonds": "demandes_fonds",
  "/validations": "validation", "/partenariat": "partenariat",
  "/finance": "finance", "/charges": "charges", "/impots": "impots", "/cotisations": "cotisations",
  "/paie": "paie", "/contrats-travail": "paie", "/elements-paie": "paie", "/bulletins": "paie",
  "/campagnes": "admin", "/courrier": "courrier", "/courrier/recus": "courrier", "/courrier/envoyes": "courrier", "/courriers": "courrier", "/courriers/nouveau": "courrier", "/courriers/modeles": "courrier", "/courriers/parametres": "courrier", "/appels": "appels", "/visiteurs": "visiteurs",
  "/comptabilite": "comptabilite", "/plan-comptable": "comptabilite", "/journaux": "comptabilite",
  "/exercices": "comptabilite", "/ecritures": "comptabilite", "/tva": "comptabilite", "/etats-comptables": "comptabilite",
  "/generation-comptable": "comptabilite", "/rapprochement": "comptabilite", "/immobilisations": "comptabilite",
  "/declaration-tva": "comptabilite", "/lettrage": "comptabilite",
  "/utilisateurs": "utilisateurs", "/parametres": "parametres",
  "/rapports-collaborateurs": "rapports_activite", "/mapping-comptable": "comptabilite", "/rapports": "rapports",
  "/formation": "ressources", "/guides": "ressources",
  "/technique": "technique", "/technique/suivi": "technique", "/portail-admin": "portail",
  "/vi": "itinerant", "/vi/ma-tournee": "itinerant", "/vi/tournees": "itinerant", "/vi/tricycles": "itinerant", "/vi/circuits": "itinerant",
  "/vi/clients": "itinerant", "/vi/stock": "itinerant", "/vi/ventes": "itinerant", "/vi/encaissements": "itinerant", "/vi/retours": "itinerant",
  "/vi/depenses": "itinerant", "/vi/inventaires": "itinerant", "/vi/rapports": "itinerant", "/vi/parametres": "itinerant",
  "/vi/commandes": "itinerant", "/vi/visites": "itinerant", "/vi/devis": "itinerant", "/vi/objectifs": "itinerant", "/vi/commissions": "itinerant", "/vi/rentabilite": "itinerant", "/vi/a-visiter": "itinerant", "/vi/conflits": "itinerant", "/vi/carte": "itinerant", "/vi/alertes-gps": "itinerant", "/vi/rapport-km": "itinerant",
};
export const routeModule = (path) => {
  if (ROUTE_MODULE[path]) return ROUTE_MODULE[path];
  const key = Object.keys(ROUTE_MODULE).filter((k) => k !== "/" && path.startsWith(`${k}/`)).sort((a, b) => b.length - a.length)[0];
  return key ? ROUTE_MODULE[key] : undefined;
};
export const permCan = (perms, module, action = "read") => {
  const val = (perms || {})[module];
  const allowed = val && typeof val === "object"
    ? Object.keys(val).filter((a) => val[a])
    : ((MODULE_ACTION_LEVELS[module] || LEVEL_ACTIONS)[val || "aucun"] || []);
  if (action === "read") return allowed.includes("view");
  if (action === "write") return allowed.includes("create") || allowed.includes("edit");
  return allowed.includes(action);
};
export const PERM_ACTIONS = [
  { value: "view", label: "Voir" }, { value: "create", label: "Créer" }, { value: "edit", label: "Modifier" },
  { value: "delete", label: "Supprimer" }, { value: "validate", label: "Valider" },
  { value: "export", label: "Exporter" }, { value: "configure", label: "Configurer" },
];
// Miroir EXACT de la barre latérale (section + intitulé) → module RBAC sous-jacent.
// Chaque entrée du menu est affichée individuellement dans la matrice de droits.
export const PERM_NAV = [
  { section: "Pilotage", items: [
    { label: "Tableau de bord", module: "dashboard" },
  ] },
  { section: "Commercial", items: [
    { label: "Prospects", module: "prospects" },
    { label: "Clients", module: "clients" },
    { label: "Projets clients", module: "projets_clients" },
    { label: "Opportunités", module: "opportunites" },
    { label: "Devis", module: "devis" },
    { label: "Prestations", module: "prestations" },
    { label: "Artisans", module: "artisans" },
    { label: "Factures", module: "factures" },
    { label: "Contrats", module: "contrats" },
    { label: "Modèles de contrats", module: "modeles_contrats" },
    { label: "Livraisons", module: "livraisons" },
  ] },
  { section: "Stock & Achats", items: [
    { label: "Articles", module: "stock" },
    { label: "Mouvements", module: "mouvements" },
    { label: "Achats", module: "achats" },
    { label: "Commandes", module: "commandes" },
    { label: "Inventaire", module: "inventaire" },
    { label: "Magasins", module: "magasins" },
    { label: "Fournisseurs", module: "fournisseurs" },
  ] },
  { section: "Projets internes", items: [
    { label: "Projets internes", module: "projets" },
    { label: "Tâches", module: "taches" },
    { label: "Agenda", module: "agenda" },
  ] },
  { section: "Collaborateurs & Temps", items: [
    { label: "Collaborateurs", module: "rh" },
    { label: "Ouvriers", module: "ouvriers" },
    { label: "Rapports d'activité", module: "rapports_activite" },
    { label: "Pointage", module: "pointage" },
    { label: "Feuilles de temps", module: "feuilles_temps" },
    { label: "Congés & Absences", module: "conges" },
  ] },
  { section: "Trésorerie", items: [
    { label: "Caisses & Banques", module: "tresorerie" },
    { label: "Demandes de fonds", module: "demandes_fonds" },
  ] },
  { section: "Finance / Compta", items: [
    { label: "Finance — Tableau de bord", module: "finance" },
    { label: "Charges", module: "charges" },
    { label: "Impôts & taxes", module: "impots" },
    { label: "Cotisations sociales", module: "cotisations" },
    { label: "Créances", module: "creances" },
    { label: "Dettes", module: "dettes" },
  ] },
  { section: "Comptabilité", items: [
    { label: "Comptabilité", module: "comptabilite" },
  ] },
  { section: "RH — Paie", items: [
    { label: "Paie", module: "paie" },
  ] },
  { section: "Vente itinérante", items: [
    { label: "Vente itinérante (tous les écrans)", module: "itinerant" },
  ] },
  { section: "Technique", items: [
    { label: "Technique (tableau de bord & dossiers)", module: "technique" },
  ] },
  { section: "Portail client", items: [
    { label: "Portail client (accès, publications, messages)", module: "portail" },
  ] },
  { section: "Administration", items: [
    { label: "Campagnes", module: "admin" },
    { label: "Courrier", module: "courrier" },
    { label: "Journal d'appels", module: "appels" },
    { label: "Visiteurs", module: "visiteurs" },
    { label: "Utilisateurs", module: "utilisateurs" },
    { label: "Paramètres", module: "parametres" },
  ] },
  { section: "Outils", items: [
    { label: "Formation & Guides", module: "ressources" },
    { label: "Rapports", module: "rapports" },
  ] },
];
export const FUND_CATEGORIES = ["achat", "déplacement", "prestation", "matériel", "avance", "divers"];

// Profils de droits réutilisables : appliqués en 1 clic à la matrice de permissions (niveaux par module).
// L'administrateur peut ensuite affiner. Non listé ici => module hérité du rôle.
export const PERM_SUBMODULES = {
  opportunites: "prospects", projets_clients: "clients",
  prestations: "devis", contrats: "devis", modeles_contrats: "devis",
  mouvements: "stock", inventaire: "stock", magasins: "stock",
  taches: "projets", agenda: "projets",
  rapports_activite: "rh", pointage: "rh", feuilles_temps: "rh", conges: "rh",
  demandes_fonds: "tresorerie", charges: "finance", impots: "finance", cotisations: "finance",
  courrier: "admin", appels: "admin", visiteurs: "admin", utilisateurs: "parametres",
};
// Profils prédéfinis exprimés par module parent : on recopie le niveau sur chaque sous-menu.
export const expandPerms = (perms) => {
  const out = { ...perms };
  Object.entries(PERM_SUBMODULES).forEach(([s, p]) => { if (p in out && !(s in out)) out[s] = out[p]; });
  return out;
};
export const PERM_PROFILES = [
  { value: "chef_chantier", label: "Chef de chantier", perms: {
    dashboard: "basique", projets: "total", ouvriers: "total", stock: "intermediaire",
    livraisons: "intermediaire", commandes: "intermediaire", artisans: "basique", rh: "basique",
  } },
  { value: "livreur", label: "Livreur", perms: {
    dashboard: "basique", livraisons: "intermediaire", stock: "basique", commandes: "basique",
  } },
  { value: "commercial", label: "Commercial", perms: {
    dashboard: "basique", prospects: "intermediaire", clients: "intermediaire", devis: "intermediaire",
    factures: "basique", livraisons: "intermediaire", artisans: "basique", projets: "basique",
  } },
  { value: "graphiste", label: "Graphiste", perms: {
    dashboard: "basique", projets: "intermediaire", devis: "basique", admin: "basique",
  } },
  { value: "assistante_admin", label: "Assistante administrative", perms: {
    dashboard: "basique", admin: "total", rh: "intermediaire", clients: "basique",
    prospects: "basique", factures: "basique", devis: "basique",
  } },
];

export const PIPELINE_STAGES = [
  "Nouveau", "À contacter", "Contact établi", "Qualification", "Rendez-vous",
  "Visite / étude", "Devis à préparer", "Devis envoyé", "Négociation",
  "Contrat à signer", "Gagné", "Perdu",
];

export const TASK_STATUSES = ["À faire", "En cours", "Bloquée", "Terminée"];

export const QUOTE_STATUSES = ["Brouillon", "Envoyé", "Vu", "Négociation", "Accepté", "Refusé", "Expiré"];
export const INVOICE_STATUSES = ["Émise", "Partiellement payée", "Payée", "En retard", "Annulée"];
export const PAYMENT_MODES = ["Espèces", "Virement bancaire", "Mobile Money", "Chèque", "Carte bancaire", "Autre"];
export const DELIVERY_STATUSES = ["Préparation", "Prête à expédier", "Expédiée", "En cours de livraison", "Livrée", "Confirmée", "Annulée"];
export const CONTRACT_STATUSES = ["À signer", "Signé", "En cours", "Terminé", "Annulé"];
export const PROJECT_STATUSES = ["À préparer", "Planifié", "En cours", "En pause", "En retard", "Terminé", "Annulé"];
export const PRIORITIES = ["Basse", "Moyenne", "Haute", "Critique"];
export const INTEREST = ["Faible", "Moyen", "Élevé"];

// badge color by status/value
export function badgeClass(v) {
  const map = {
    // success
    "Gagné": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "Accepté": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "Signé": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "Terminé": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "Terminée": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "Validé": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "Approuvé": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "Actif": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "Élevé": "bg-emerald-50 text-emerald-700 border-emerald-200",
    // blue in progress
    "En cours": "bg-brand-50 text-brand-700 border-brand-200",
    "Envoyé": "bg-brand-50 text-brand-700 border-brand-200",
    "Vu": "bg-brand-50 text-brand-700 border-brand-200",
    "Soumis": "bg-brand-50 text-brand-700 border-brand-200",
    "Décaissé": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "Payée": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "Totalement payée": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "Émise": "bg-brand-50 text-brand-700 border-brand-200",
    "Non échue": "bg-slate-100 text-slate-600 border-slate-200",
    "Soldée": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "En attente": "bg-slate-100 text-slate-600 border-slate-200",
    "Préparation": "bg-slate-100 text-slate-600 border-slate-200",
    "Prête à expédier": "bg-amber-50 text-amber-700 border-amber-200",
    "Expédiée": "bg-brand-50 text-brand-700 border-brand-200",
    "En cours de livraison": "bg-brand-50 text-brand-700 border-brand-200",
    "Livrée": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "Confirmée": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "Validé": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "Brouillon": "bg-slate-100 text-slate-600 border-slate-200",
    "Partiellement payée": "bg-amber-50 text-amber-700 border-amber-200",
    "physique": "bg-brand-50 text-brand-700 border-brand-200",
    "electronique": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "banque": "bg-indigo-50 text-indigo-700 border-indigo-200",
    "autre": "bg-slate-100 text-slate-600 border-slate-200",
    "Payée": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "Payé": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "Partiellement payé": "bg-amber-50 text-amber-700 border-amber-200",
    // amber attente
    "En attente": "bg-amber-50 text-amber-700 border-amber-200",
    "Négociation": "bg-amber-50 text-amber-700 border-amber-200",
    "À signer": "bg-amber-50 text-amber-700 border-amber-200",
    "Planifié": "bg-amber-50 text-amber-700 border-amber-200",
    "En pause": "bg-amber-50 text-amber-700 border-amber-200",
    "Brouillon": "bg-slate-100 text-slate-600 border-slate-200",
    "À faire": "bg-slate-100 text-slate-600 border-slate-200",
    "À préparer": "bg-slate-100 text-slate-600 border-slate-200",
    "Moyen": "bg-amber-50 text-amber-700 border-amber-200",
    "Moyenne": "bg-amber-50 text-amber-700 border-amber-200",
    // danger
    "Perdu": "bg-rose-50 text-rose-700 border-rose-200",
    "Refusé": "bg-rose-50 text-rose-700 border-rose-200",
    "Rejeté": "bg-rose-50 text-rose-700 border-rose-200",
    "Annulé": "bg-rose-50 text-rose-700 border-rose-200",
    "Annulée": "bg-rose-50 text-rose-700 border-rose-200",
    "Bloquée": "bg-rose-50 text-rose-700 border-rose-200",
    "En retard": "bg-rose-50 text-rose-700 border-rose-200",
    "Haute": "bg-orange-50 text-orange-700 border-orange-200",
    "Critique": "bg-rose-50 text-rose-700 border-rose-200",
    "Basse": "bg-slate-100 text-slate-600 border-slate-200",
    "Faible": "bg-slate-100 text-slate-600 border-slate-200",
  };
  return map[v] || "bg-slate-100 text-slate-600 border-slate-200";
}
